export const PROBE = "Probe";
export const SELECT = "bitte wählen";